var _style, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconReplenishmentViaBusinessCard = function SvgIconReplenishmentViaBusinessCard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 12",
    style: {
      enableBackground: "new 0 0 16 12"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#group-19-b_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st5{mask:url(#group-19-d_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st7{mask:url(#group-19-d_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st9{mask:url(#group-19-d_3_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_4_);}\n\t.st11{mask:url(#group-19-d_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st12{filter:url(#Adobe_OpacityMaskFilter_5_);}\n\t.st13{mask:url(#group-19-d_5_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_6_);}\n\t.st15{mask:url(#group-19-d_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st16{filter:url(#Adobe_OpacityMaskFilter_7_);}\n\t.st17{mask:url(#group-19-d_7_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n\t.st18{filter:url(#Adobe_OpacityMaskFilter_8_);}\n\t.st19{mask:url(#group-19-d_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5C4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,0.7h-12c-0.9,0-1.7,0.8-1.7,1.8v7c0,1,0.8,1.8,1.7,1.8h12c0.9,0,1.7-0.8,1.7-1.8v-7 C15.6,1.5,14.8,0.7,13.8,0.7 M13.8,1.4c0.6,0,1,0.5,1,1.1v7c0,0.6-0.5,1.1-1,1.1h-12c-0.6,0-1-0.5-1-1.1v-7c0-0.6,0.5-1.1,1-1.1 H13.8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .172)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0.4,
    width: 15.7,
    height: 10.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.4,
    width: 15.7,
    height: 10.8,
    id: "group-19-b_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-a_1_",
    className: "st2",
    points: "0,0.4 15.7,0.4 15.7,11.3 0,11.3  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.9,1.4C1.4,1.4,1,1.8,1,2.3v7c0,0.5,0.4,0.9,0.9,0.9h12c0.5,0,0.9-0.4,0.9-0.9v-7c0-0.5-0.4-0.9-0.9-0.9 H1.9z M13.8,10.6h-12c-0.6,0-1.2-0.5-1.2-1.2v-7c0-0.7,0.5-1.2,1.2-1.2h12c0.6,0,1.2,0.5,1.2,1.2v7C15,10,14.5,10.6,13.8,10.6 L13.8,10.6z M1.9,0.7C1,0.7,0.3,1.4,0.3,2.3v7C0.3,10.2,1,11,1.9,11h12c0.9,0,1.6-0.7,1.6-1.6v-7c0-0.9-0.7-1.6-1.6-1.6H1.9z  M13.8,11.3h-12c-1,0-1.9-0.9-1.9-1.9v-7c0-1.1,0.8-1.9,1.9-1.9h12c1,0,1.9,0.9,1.9,1.9v7C15.7,10.4,14.9,11.3,13.8,11.3 L13.8,11.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,2.1c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4C4.4,2.8,3.7,2.1,3,2.1 M3,2.8 c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7S2.3,3.9,2.3,3.5C2.3,3.2,2.6,2.8,3,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,2.1C3.6,2.1,3,2.8,3,3.5c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4C5.8,2.8,5.1,2.1,4.4,2.1 M4.4,2.8 c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7C4,4.2,3.7,3.9,3.7,3.5C3.7,3.2,4,2.8,4.4,2.8"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 8.5,
    y: 3.5,
    width: 5.6,
    height: 0.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.5,
    y: 3.5,
    width: 5.6,
    height: 0.7,
    id: "group-19-d_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_1_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "8.5,4.2 14.1,4.2 14.1,3.5 8.5,3.5  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 8.4,
    y: 3.4,
    width: 5.9,
    height: 1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.4,
    y: 3.4,
    width: 5.9,
    height: 1,
    id: "group-19-d_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_2_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M8.7,4.1H14V3.7H8.7V4.1z M8.4,4.4h5.9v-1H8.4V4.4z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 2.2,
    y: 8.4,
    width: 2.8,
    height: 0.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 2.2,
    y: 8.4,
    width: 2.8,
    height: 0.7,
    id: "group-19-d_3_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_3_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2.2,9.1 5,9.1 5,8.4 2.2,8.4  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 2.1,
    y: 8.3,
    width: 3.1,
    height: 1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 2.1,
    y: 8.3,
    width: 3.1,
    height: 1,
    id: "group-19-d_4_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_4_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2.4,9h2.5V8.6H2.4V9z M2.1,9.3h3.1v-1H2.1V9.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 10.6,
    y: 8.4,
    width: 2.8,
    height: 0.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.6,
    y: 8.4,
    width: 2.8,
    height: 0.7,
    id: "group-19-d_5_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_5_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "10.6,9.1 13.4,9.1 13.4,8.4 10.6,8.4  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 10.5,
    y: 8.3,
    width: 3.1,
    height: 1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.5,
    y: 8.3,
    width: 3.1,
    height: 1,
    id: "group-19-d_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_6_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M10.8,9h2.5V8.6h-2.5V9z M10.5,9.3h3.1v-1h-3.1V9.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 6.4,
    y: 8.4,
    width: 2.8,
    height: 0.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6.4,
    y: 8.4,
    width: 2.8,
    height: 0.7,
    id: "group-19-d_7_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_7_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "6.4,9.1 9.2,9.1 9.2,8.4 6.4,8.4  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: 6.3,
    y: 8.3,
    width: 3.1,
    height: 1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6.3,
    y: 8.3,
    width: 3.1,
    height: 1,
    id: "group-19-d_8_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "group-19-c_8_",
    className: "st2",
    points: "0,11.4 15.7,11.4 15.7,0.6 0,0.6  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M6.6,9h2.5V8.6H6.6V9z M6.3,9.3h3.1v-1H6.3V9.3z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReplenishmentViaBusinessCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-replenishment-via-business-card.9adf5a5a.svg";
export { ForwardRef as ReactComponent };